import { FC, createContext, useContext } from 'react';

export type Authentication = unknown & { accessToken: string; refreshToken: string };

interface ElementsEnvironmentContextProps {
  app: 'advisor' | 'client';
  isDev?: boolean;
  /** Full GraphQL endpoint URL, derived from the app's API_BASE_URL. Overrides the hardcoded dev/prod URLs in useApiUrl so personal SST stages work (ELE-548). */
  apiUrl?: string;
  isInsiders?: boolean;
  children?: React.ReactNode;
  householdID?: string | undefined | null;
  authentication: Authentication | undefined | null;
}

const ElementsEnvironmentContext = createContext<ElementsEnvironmentContextProps | null>(null);

export const useElementsEnvironmentContext = () => {
  const context = useContext(ElementsEnvironmentContext);

  if (!context) {
    throw new Error('Make sure to use the ElementsEnvironmentContext inside of the provider');
  }

  return context;
};

export const ElementsEnvironmentContextProvider: FC<ElementsEnvironmentContextProps> = ({ children, ...props }) => {
  return <ElementsEnvironmentContext.Provider value={props}>{children}</ElementsEnvironmentContext.Provider>;
};
